export default "/images/vendor/flag-icons/flags/4x3/bh.svg?3310879d5f14a62669bfedce94492cba";